export const SET_CUSTOMER_INFO = 'SET_CUSTOMER_INFO';
export const SET_CUSTOMER_ADDRESS_INFO = 'SET_CUSTOMER_ADDRESS_INFO';
export const UPDATE_CUSTOMER_ADDRESS = 'UPDATE_CUSTOMER_ADDRESS';
export const UPDATE_CUSTOMER_LOGGEDIN_STATUS =
  'UPDATE_CUSTOMER_LOGGEDIN_STATUS';
